import { useState, useEffect } from 'react';

import { getCountryCode, getLocale } from '../config/globalStates';
import {
  SEEKMAX_APP_LINK_MY,
  SEEKMAX_APP_LINK_PH,
  SEEKMAX_APP_LINK_ID_EN,
  SEEKMAX_APP_LINK_ID_ID,
  SEEKMAX_APP_LINK_SG,
} from '../domain/constants';

export const useGetAppLink = (): string => {
  // Default for SSR to ensure consistent initial render
  const [appLink, setAppLink] = useState('');

  useEffect(() => {
    const countryCode = getCountryCode();
    const localeCode = getLocale();
    const appLinksMapper: Record<string, string> = {
      MY: SEEKMAX_APP_LINK_MY,
      PH: SEEKMAX_APP_LINK_PH,
      ID:
        localeCode === 'en-ID'
          ? SEEKMAX_APP_LINK_ID_EN
          : SEEKMAX_APP_LINK_ID_ID,
      SG: SEEKMAX_APP_LINK_SG,
    };

    setAppLink(appLinksMapper[countryCode] || '');
  }, []);

  return appLink;
};
